import React, { Component } from "react";
import "./ModalChangeClient.css";

import {
    TRANSFER_TYPE_ACTIVITY
} from "../../core/constants";

import Modal from 'react-bootstrap/Modal';
import { AiOutlineClose } from 'react-icons/ai';
import InputSearch from "./InputSearch";
import ButtonIcon from "./ButtonIcon";
import Select from "./Select";

import ClientController from "../../controllers/ClientController";
import BusinessController from "../../controllers/BusinessController";
import ActivityController from "../../controllers/ActivityController";
import MessageConfirmation from "./MessageConfirmation";

const clientController = new ClientController();
const businessController = new BusinessController();
const activityController = new ActivityController();

const initialState = {
    valueSearch:"",
    dataSearch: [],
    clientId: null,
    showModalConfirmChangeUnit: false,
    message_type: "",
    message: "",
    message_show: false,
    chosenCompanyUnit: null,
    optionsCompanyUnits: [],
}

export default class ModalChangeClient extends Component
{
    state = {...initialState};

    componentDidMount = async () =>
    {
        await this.setState({
            optionsCompanyUnits: this.props.optionsCompanyUnit,
            chosenCompanyUnit: this.props.optionsCompanyUnit.find((e) => e.value === this.props.optionChosenCompanyUnit.value)
        })
    }

    componentDidUpdate = async (prevProps) =>
    {
        if (prevProps.optionChosenCompanyUnit !== this.props.optionChosenCompanyUnit)
        {
            await this.setState({
                optionsCompanyUnits: this.props.optionsCompanyUnit,
                chosenCompanyUnit: this.props.optionsCompanyUnit.find((e) => e.value === this.props.optionChosenCompanyUnit.value)
            })
        }
    }

    saveNewClientOnAllActivities = async () =>
    {
        try
        {
            await activityController.updateClientActivities({
                "fromClientId": this.props.currentClient.id,
                "toClientId": this.state.clientId
            })
        }
        catch (error)
        {
            console.error(error);
        }
    }

    createHistoric = async () =>
    {
        const annotations = `● Substituiu ${this.props.currentClient.name} como cliente desse negócio.`;

        const result = await activityController.create({
            ACT_TITLE: "MUDANÇA DE CLIENTE",
            ACT_TYPE: TRANSFER_TYPE_ACTIVITY,
            ACT_ANNOTATIONS: annotations.toUpperCase(),
            ACT_ID_BUSINESS: this.props.businessId,
            ACT_ID_PERSON_CLIENT: this.state.clientId,
            ACT_ID_CREATE_PERSON: this.props.user.PER_ID,
            ACT_FINISHED: 1
        });

        if (!result.status)
        {
            return;
        }

        await this.saveNewClientOnAllActivities();
        await this.props.onSaveActivity();
    }

    changeClient = async () => {
        const data = {
            BUS_ID_PERSON_CLIENT: this.state.clientId
        };

        if (this.state.clientId !== null && this.state.clientId !== this.props.currentClient.id)
        {
            await businessController.update(this.props.businessId, data);
            await this.createHistoric();
        }

        this.props.onClose();
    }

    handleSelectHistoricItem = async (item) => {
        await this.setState({ clientName: item.name, clientId: item.id });

        if (item.companyId !== this.props.currentClient.companyId)
        {
            await this.openModalConfirmChangeUnit();
        }
        else
        {
            await this.changeClient();
        }
    };

    openModalConfirmChangeUnit = async () =>
    {
        await this.setState({ showModalConfirmChangeUnit: true });
        // await this.props.onClose();
    }

    search = async (value) =>
    {
        await this.setState({dataSearch: [], valueSearch: value});
        let rows = [];

        if (value !== "")
        {
            if (value.length >= 4) 
            {
                const result = await clientController.searchClients({
                    companyId: this.state.chosenCompanyUnit.value,
                    search: value
                });

                if (result.status)
                {
                    let person = result.data;

                    person = person.sort(function (a, b) 
                    {
                        if (a.PER_NAME > b.PER_NAME) 
                        {
                            return 1;
                        }
                        if (a.PER_NAME < b.PER_NAME) 
                        {
                            return -1;
                        }
                        return 0;
                    });

                    person = person.sort(function (a, b) 
                    {
                        if (a.UNT_NAME > b.UNT_NAME) 
                        {
                            return 1;
                        }
                        if (a.UNT_NAME < b.UNT_NAME) 
                        {
                            return -1;
                        }
                        return 0;
                    });

                    for (const row of person)
                    {
                        rows.push({
                            type: "lead",
                            id: row.PER_ID,
                            item: row.PER_NAME,
                            name: row.PER_NAME,
                            phone: row.PER_PHONE_ONE,
                            companyId: row.PER_ID_COMPANY_UNIT,
                            companyUnit: row.companyUnit.UNT_NAME,
                            statusCurrentCompanyUnit: row.PER_ID_COMPANY_UNIT === this.props.currentClient.companyId,
                        });
                    }
                }
            }
        }
        
        await this.setState({ dataSearch: rows });
    }

    onSaveActivity = () =>
    {
        this.props.onSaveActivity()
    }

    render() {
        return (
            <div>
                {
                    this.state.showModalConfirmChangeUnit &&
                        <MessageConfirmation
                            show={this.state.showModalConfirmChangeUnit}
                            message_type={"warning"}
                            showButtonYes={true}
                            onClickNo={() => this.setState({ showModalConfirmChangeUnit: false })}
                            onClickYes={async () => {
                                await this.changeClient();
                            }}
                            onClose={() => this.setState({ showModalConfirmChangeUnit: false })}
                        >
                            <span>Você está trocando o cliente atual para um cliente de <b>OUTRA UNIDADE</b> neste <b>NEGÓCIO</b>. Deseja prosseguir?</span>
                            <p></p>
                        </MessageConfirmation>
                }
                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="modalChangeClient"
                >
                    <div className="content">
                        <div className="header">
                            <span className="status">
                                <i className="fas fa-exchange-alt mr-2" />
                                Alterar Cliente do Negócio
                            </span>
                            <button className="close" onClick={() => this.props.onClose()}>
                                <AiOutlineClose className="iconButton" />
                            </button>
                        </div>
                        <div className="body">
                            <div className="row marginBottomModalChangeClient">
                                <div
                                    className="col-12"
                                >
                                    <Select
                                        label="Unidade"
                                        withFieldSearch
                                        default={this.state.chosenCompanyUnit}
                                        placeholder={"Selecione uma unidade..."}
                                        options={this.state.optionsCompanyUnits} 
                                        onChange={async (chosenCompanyUnit) => {
                                            this.setState({chosenCompanyUnit});
                                        }}
                                    />
                                </div>
                            </div>
                            <hr />
                            <div className="row containerModalChangeClient">
                                <div
                                    className="col-11"
                                >
                                    <InputSearch
                                        onChange={(e) => this.search(e.target.value)}
                                        onClearInputSearch={() =>
                                            this.setState({ dataSearch: [], valueSearch: "" })
                                        }
                                        placeholder="Pesquise por nome ou telefone do cliente..."
                                        value={this.state.valueSearch}
                                        data={this.state.dataSearch}
                                        permissions={this.props.permissions}
                                        onSelectItem={this.handleSelectHistoricItem}
                                    />
                                </div>
                                {
                                    (this.props.permissions.leads.toInsert) &&
                                    (
                                        <div
                                            className="col-1"
                                        >
                                            <ButtonIcon
                                                icon="fal fa-plus"
                                                classaditional="buttonModalChangeClient"
                                                onClick={async () => {
                                                    await this.props.openModalCreatePerson();
                                                    await this.props.onClose();
                                                }}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
